var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { EventEmitter, Renderer2 } from '@angular/core';
import { AchooFilterBoxComponent } from '../../../../core/achoo-filter-box/achoo-filter-box.component';
import { UserService } from '../../../../services/user.service';
import { ValidationHandlerService } from '../../../../core/validation-handler.service';
import { Page, TargetType, UserActionType } from '../../../../services/event-tracker/event-tracker.service';
import { InfluencerService } from '../../../../services/influencer/influencer.service';
import { DeviceDetectorService } from 'ngx-device-detector';
var DemographicSourceSelectionComponent = /** @class */ (function (_super) {
    __extends(DemographicSourceSelectionComponent, _super);
    function DemographicSourceSelectionComponent(userService, influencerService, validationHandlerService, renderer, deviceDetector) {
        var _this = _super.call(this, validationHandlerService, deviceDetector, renderer) || this;
        _this.userService = userService;
        _this.influencerService = influencerService;
        _this.validationHandlerService = validationHandlerService;
        _this.renderer = renderer;
        _this.deviceDetector = deviceDetector;
        _this.selectDemographicSourceEvent = new EventEmitter();
        _this.mpEventData = {
            action: UserActionType.VIEW,
            item: Page.DEMOGRAPHICS,
            target: {
                id: _this.influencerService.influencerDetails.id,
                name: _this.influencerService.influencerDetails.name,
                type: TargetType.INFLUENCER
            }
        };
        return _this;
    }
    DemographicSourceSelectionComponent.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
        this.disabled = this.userService.isFreeUser() && !this.userService.isAdmin;
    };
    DemographicSourceSelectionComponent.prototype.onSelectDemographicSource = function (evt) {
        this.selectDemographicSourceEvent.emit(evt);
    };
    Object.defineProperty(DemographicSourceSelectionComponent.prototype, "selectPlatform", {
        get: function () {
            var _this = this;
            var selectSource = this.dataSources.find(function (s) { return s.id === _this.model; });
            return selectSource ? selectSource.platformName : '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DemographicSourceSelectionComponent.prototype, "eventData", {
        get: function () {
            return {
                action: UserActionType.VIEW,
                item: Page.DEMOGRAPHICS,
                target: {
                    id: this.influencerService.influencerDetails.id,
                    name: this.influencerService.influencerDetails.name,
                    type: TargetType.INFLUENCER
                }
            };
        },
        enumerable: true,
        configurable: true
    });
    return DemographicSourceSelectionComponent;
}(AchooFilterBoxComponent));
export { DemographicSourceSelectionComponent };



// WEBPACK FOOTER //
// ./src/app/main/influencer/demographic/demographic-source-selection/demographic-source-selection.component.ts.pre-build-optimizer.js